﻿import LandingPage from "./Registration/LandingPage.svelte";
import PersonalDetails from "./Registration/PersonalDetails.svelte";
import ActionSpecific from "./Registration/ActionSpecific.svelte";
import Confirmation from "./Registration/Confirmation.svelte";
import Review from "./Registration/Review.svelte";
import ThankYou from "./Registration/ThankYou.svelte";
import SaveAndCloseThankYou from "./Registration/SaveAndCloseThankYou.svelte";
import Verify from "./Registration/Verify.svelte";
import RegistrationComplete from "./Registration/RegistrationComplete.svelte";

import Survey from "./Survey/Survey.svelte";
import SurveyConfirmation from "./Survey/Confirmation.svelte";
import SurveyThankYou from "./Survey/ThankYou.svelte";
import SurveyReview from "./Survey/Review.svelte";
import SurveyComplete from "./Survey/SurveyComplete.svelte";

import Error from "./Error.svelte";

import { projectSettings } from "../config";

export const surveyPageList = [
	{
		pageIndex: 0,
		component: Survey,
		title: "Survey",
		showInTracker: true,
		routeId: "/Survey",
		previousPage: "/Survey",
		nextPage: "/Survey/Confirmation",
		properties: {
			pageTitle: `${projectSettings.classActionName} - Survey`,
			persistUrl: "/api/project",
			lastVisitedPage: "Work Details"
		}
	},
	{
		pageIndex: 1,
		component: SurveyConfirmation,
		title: "Confirmation",
		showInTracker: true,
		routeId: "/Survey/Confirmation",
		previousPage: "/Survey",
		nextPage: "/Survey/ThankYou",
		properties: {
			pageTitle: `${projectSettings.classActionName} - Confirmation`,
			nextPageLabel: "Submit",
			persistUrl: `/api/survey`,
			lastVisitedPage: "Confirmation"
		}
	},
	{
		pageIndex: 2,
		component: SurveyThankYou,
		title: "Survey Submitted",
		showInTracker: false,
		routeId: "/Survey/ThankYou",
		properties: {
			pageTitle: `${projectSettings.classActionName} - Thank you`
		}
	},
	{
		pageIndex: 5,
		component: SurveyReview,
		title: "Review",
		showInTracker: false,
		routeId: "/Survey/Review",
		properties: {
			pageTitle: `${projectSettings.classActionName} - Review`
		}
	},
	{
		pageIndex: 5,
		component: SurveyComplete,
		title: "Complete",
		showInTracker: false,
		routeId: "/SurveyComplete",
		properties: {
			pageTitle: `${projectSettings.classActionName} - Complete`
		}
	},
]

export const registrationPageList = [
	{
		pageIndex: 0,
		component: RegistrationComplete,
		title: "REGISTRATION SUBMITTED",
		showInTracker: false,
		routeId: "/RegistrationComplete",
		properties: {
			pageTitle: `${projectSettings.classActionName}`
		}
	},
	{
		pageIndex: 0,
		component: LandingPage,
		title: "Claimant Registration Form",
		showInTracker: true,
		routeId: "/Registration",
		//nextPage: "/Registration/ActionSpecific",
		nextPage: "/Registration/PersonalDetails",
		properties: {
			pageTitle: `${projectSettings.classActionName}`,
			lastVisitedPage: "Landing Page"
		}
	},
	{
		pageIndex: 1,
		component: PersonalDetails,
		title: "Personal Details",
		showInTracker: true,
		routeId: "/Registration/PersonalDetails",
		nextPage: (model) => (model.confirmationPage ? "/Registration/Confirmation" : "/Registration/ActionSpecific"),
		previousPage: "/Registration",
		properties: {
			pageTitle: `${projectSettings.classActionName} - Personal Details`,
			persistUrl: "/api/project",
			lastVisitedPage: "Personal Details"
		}
	},
	{
		pageIndex: 2,
		component: ActionSpecific,
		title: "Work Details",
		showInTracker: true,
		routeId: "/Registration/ActionSpecific",
		previousPage: "/Registration/PersonalDetails",
		nextPage: "/Registration/Confirmation",
		properties: {
			pageTitle: `${projectSettings.classActionName} - Work Details`,
			persistUrl: "/api/project",
			lastVisitedPage: "Work Details"
		}
	},
	{
		pageIndex: 3,
		component: Confirmation,
		title: "Confirmation",
		showInTracker: true,
		routeId: "/Registration/Confirmation",
		previousPage: "/Registration/ActionSpecific",
		nextPage: "/Registration/ThankYou",
		properties: {
			pageTitle: `${projectSettings.classActionName} - Confirmation`,
			nextPageLabel: "Submit",
			persistUrl: `/api/registration?timezoneOffset=${-1 * new Date().getTimezoneOffset()}`,
			lastVisitedPage: "Confirmation"
		}
	},
	{
		pageIndex: 4,
		component: ThankYou,
		title: "Registration Submitted",
		showInTracker: false,
		routeId: "/Registration/ThankYou",
		properties: {
			pageTitle: `${projectSettings.classActionName} - Thank you`
		}
	},
	{
		pageIndex: 4,
		component: SaveAndCloseThankYou,
		title: "Registration Saved",
		showInTracker: false,
		routeId: "/Registration/SaveAndClose",
		properties: {
			pageTitle: `${projectSettings.classActionName} - Thank you`
		}
	},
	{
		pageIndex: 5,
		component: Review,
		title: "Review",
		showInTracker: false,
		routeId: "/Review",
		properties: {
			pageTitle: `${projectSettings.classActionName} - Review`
		}
	},
	{
		pageIndex: 6,
		component: Verify,
		title: "Claimant Registration Form",
		showInTracker: false,
		routeId: "/Verify",
		nextPage: "/Registration/PersonalDetails",
		properties: {
			pageTitle: `${projectSettings.classActionName} - Verify`
		}
	},
	{
		pageIndex: 7,
		component: Error,
		title: "Error",
		showInTracker: false,
		routeId: "*/Error",
		properties: {
			pageTitle: `${projectSettings.classActionName} - Error`
		}
	}
];
